/**
 * BrandListContainer
 *
 * --
 *
 */

import React, { useState, useEffect } from 'react';
import BrandListPresenter from './BrandListPresenter';
import { ShopInformationApi } from 'api';
import MessageAlert from 'utils';

/**----------------------------------------
 * [Component] 입점업체 목록
 * ----------------------------------------
 */
const BrandListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [shopList, setShopList] = useState([]);
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**--------------------
   * 심사상태변경
   * --------------------
   */
  const handleChangeShopInformation = ({
    shop_information_id,
    application_status,
  }) => {
    const fid = shopList.findIndex(
      (s) => s.shop_information_id === shop_information_id
    );
    setShopList((prev) => [
      ...prev.slice(0, fid),
      { ...prev[fid], application_status },
      ...prev.slice(fid + 1),
    ]);
  };

  /* ===== HOOKS ===== */
  /**--------------------
   * 입점업체 목록 조회
   * --------------------
   */
  useEffect(() => {
    const call = async () => {
      try {
        const { status, message, data } =
          await ShopInformationApi.getShopInformations({
            // type: 'ALL', // [SHOP, STORE, ALL]
          });
        if (status !== 200) throw { message };

        setShopList(
          data?.filter((item) => item.type === 'ALL' || item.type === 'SHOP')
        );
      } catch (e) {
        console.log('[BrandListContainer][useEffect] Error: ', e);
        MessageAlert.error(e.message);
      }
    };
    call();
  }, []);

  /* ===== RENDER ===== */
  return (
    <>
      <BrandListPresenter
        {...{
          shopList,
          onChangeShopInformation: handleChangeShopInformation,
        }}
      />
    </>
  );
};

export default BrandListContainer;
